import React from "react";
import ExcelJS from "exceljs";
import BaseListPage from "../../../../base/BaseListPage";
import {
  countObjectUseCase,
  findObjectUseCase,
} from "../../../../usecases/object";
import Export from "../../../../components/Export/index.js";
import printChart from "../../../../PrintChart.js";
import { Progress } from "../../../../nq-component";
import TotalSalesWeekDayPresenter from "./TotalSalesWeekDayPresenter.js";
import DateRangeReport from "../../../../components/DateRangeReport/index.js";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Select from "react-select";
import DefaultState from "../../../sales-and-transactions/components/DefaultState.js";
import ProgressLoader from "../../../../components/ProgressLoader/index.js";
import InitialPrompt from "../../../../components/InitialPrompt/index.js";
import CustomSelect from "../../../../components/CustomSelect/index.js";
import PageHeader from "../../../../components/PageHeader/index.js";

const daysOfWeek = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

class TotalSalesWeekDayPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new TotalSalesWeekDayPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
    );

    this.state = {
      objects: [],
      selectedDate: new Date().toISOString().split("T")[0],
      selectedStoreCode: "",
      totalSalesPerHour: [],
      storess: "",
      store: [],
      range: "",
    };

    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleStoreCodeChange = this.handleStoreCodeChange.bind(this);
  }
  setStore(store) {
    this.setState({ store });
  }

  onChangeStore(where) {
    this.setState({ storess: where });
    this.presenter.onChangeStore(where);
  }

  onChangeDate(where) {
    this.presenter.onChangeDate(where);
    this.setState({ range: where });
  }

  getUniqueStoreCodes() {
    const storeCodes = this.state.objects.map((obj) =>
      // Remove "ANGELSPIZZA_" from the start and return the rest
      obj.store_code.replace("ANGELSPIZZA_", ""),
    );

    return [...new Set(storeCodes)]; // Remove duplicates
  }

  filterTransactions(transactions) {
    console.log("trasa", transactions);
    const selectedDate = new Date(this.state.selectedDate);
    console.log("Seee11", selectedDate);
    selectedDate.setHours(0, 0, 0, 0);

    console.log("Seee", selectedDate);

    return transactions?.filter((transaction) => {
      const transactionDate = new Date(transaction.tran_date);
      transactionDate.setHours(0, 0, 0, 0);

      const selectedDateMatch =
        transactionDate.getTime() === selectedDate.getTime();
      const storeCodeMatch = this.state.selectedStoreCode
        ? transaction.store_code.replace("ANGELSPIZZA_", "") ===
          this.state.selectedStoreCode
        : true;

      return selectedDateMatch && storeCodeMatch;
    });
  }

  handleDateChange(event) {
    this.setState({ selectedDate: event.target.value });
  }

  handleStoreCodeChange(event) {
    this.setState({ selectedStoreCode: event.target.value });
  }

  countDaysInMonth(month, year) {
    const dayCounts = {
      Sunday: 0,
      Monday: 0,
      Tuesday: 0,
      Wednesday: 0,
      Thursday: 0,
      Friday: 0,
      Saturday: 0,
    };
    // Get the number of days in the month
    const daysInMonth = new Date(year, month, 0).getDate();

    // Loop through all days in the month
    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month - 1, day); // month - 1 because JavaScript months are 0-indexed
      const weekday = daysOfWeek[date.getDay()];
      dayCounts[weekday]++;
    }

    return dayCounts;
  }

  calculateAverageSales(transactions, month, year) {
    const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const totalSales = Object.fromEntries(
      daysOfWeek.map((day) => [day, { morning: 0, afternoon: 0 }]),
    );
    const dayCountsInMonth = this.countDaysInMonth(month, year);

    transactions
      ?.filter((status) => status.status === "C")
      .forEach((transaction) => {
        const date = new Date(transaction.tran_date);
        const weekday = daysOfWeek[date.getDay()];
        const grossSales = parseFloat(transaction.total);
        const sales = grossSales - parseFloat(transaction.total_tax);

        const hour = date.getHours();
        if (hour >= 0 && hour < 5) {
          totalSales[weekday].morning += sales;
        } else {
          totalSales[weekday].afternoon += sales;
        }
      });

    return { averageSales: totalSales };
  }

  getChartData() {
    const month = new Date().getMonth(); // Example: get current month
    const year = new Date().getFullYear();

    const filteredTransactions = this.filterTransactions(this.state.objects);
    const { averageSales } = this.calculateAverageSales(
      this.state.objects,
      month,
      year,
    );

    const labels = daysOfWeek;

    // Define data for each segment of the day
    const morningSales = daysOfWeek.map(
      (day) => averageSales[day]?.morning || 0,
    );
    const afternoonSales = daysOfWeek.map(
      (day) => averageSales[day]?.afternoon || 0,
    );

    return {
      labels: labels,
      datasets: [
        {
          label: "Morning Sales (12:01 AM - 4:59 AM)",
          data: morningSales,
          backgroundColor: "#FF6384",
          borderColor: "#FF6384",
          borderWidth: 1,
        },
        {
          label: "Afternoon Sales (5:00 AM - 11:59 PM)",
          data: afternoonSales,
          backgroundColor: "#006096",
          borderColor: "#006096",
          borderWidth: 1,
        },
      ],
    };
  }

  getHighchartOptions() {
    const month = new Date().getMonth();
    const year = new Date().getFullYear();

    const { averageSales } = this.calculateAverageSales(
      this.state.objects,
      month,
      year,
    );

    const categories = daysOfWeek;
    const morningSales = daysOfWeek.map(
      (day) => averageSales[day]?.morning || 0,
    );
    const afternoonSales = daysOfWeek.map(
      (day) => averageSales[day]?.afternoon || 0,
    );

    return {
      chart: {
        type: "column",
      },
      title: {
        text: "Total Sales vs Day of Week",
      },
      xAxis: {
        categories: categories,
        title: {
          text: "Day of the Week",
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: "Sales (PHP)",
        },
        labels: {
          formatter: function () {
            return "₱" + this.value.toLocaleString();
          },
        },
      },
      tooltip: {
        shared: true,
        valuePrefix: "₱",
        valueDecimals: 2,
      },
      plotOptions: {
        column: {
          stacking: null,
          dataLabels: {
            enabled: true,
            format: "₱{point.y:.2f}",
          },
        },
      },
      series: [
        {
          name: "Morning Sales (12:01 AM - 4:59 AM)",
          data: morningSales,
          color: "#FF6384",
        },
        {
          name: "Afternoon Sales (5:00 AM - 11:59 PM)",
          data: afternoonSales,
          color: "#006096",
        },
      ],
    };
  }

  getChartOptions() {
    return {
      scales: {
        y: {
          beginAtZero: true,
        },
      },
    };
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  getCollectionName() {
    return "transactions";
  }

  convertToCSV(objArray) {
    const array =
      typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
    let str =
      `${Object.keys(array[0])
        .map((value) => `"${value}"`)
        .join(",")}` + "\r\n";
    for (let i = 0; i < array.length; i++) {
      let line = "";
      for (let index in array[i]) {
        if (line !== "") line += ",";
        line += `"${array[i][index]}"`;
      }
      str += line + "\r\n";
    }
    return str;
  }

  // exportToCSV = () => {
  //   const { storess } = this.state;
  //   const { averageSales } = this.calculateAverageSales(this.state.objects);
  //   const csvData = Object.entries(averageSales).flatMap(([day, sales]) => {
  //     const formattedSales = [
  //       { period: "Morning", amount: sales.morning },
  //       { period: "Afternoon", amount: sales.afternoon },
  //     ];
  //     return formattedSales.map((sale, index) => ({
  //       brand: "Angels Pizza",
  //       store: storess || "All Stores",
  //       date: `${this.state.range.tran_date["$lte"].split("T")[0]} ${
  //         this.state.range.tran_date["$gte"].split("T")[0]
  //       }`,
  //       time: sale.period,
  //       averageSales: `${day} - ${sale.amount.toFixed(2)}`,
  //     }));
  //   });

  //   const csvString = this.convertToCSV(csvData);
  //   const a = document.createElement("a");
  //   const blob = new Blob([csvString], { type: "text/csv" });
  //   const url = window.URL.createObjectURL(blob);

  //   a.href = url;
  //   a.download = `${"Angels Pizza"}-Total-Sales-Week.csv`;
  //   a.click();
  //   window.URL.revokeObjectURL(url);
  // };

  exportToCSV = async () => {
    const { storess } = this.state;
    const { averageSales } = this.calculateAverageSales(this.state.objects);

    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet("Total Sales by Day");

    // ===== COLORS =====
    const TITLE_BLUE = "FF0076BA";
    const HEADER_GREEN = "FF83C14A";
    const LIGHT_GRAY = "FFF2F2F2";
    const BORDER = "FFCCCCCC";

    // ===== TITLE =====
    ws.mergeCells("A1:C1");
    ws.getCell("A1").value = "Total Sales vs. Day of Week";
    ws.getCell("A1").font = {
      bold: true,
      size: 14,
      color: { argb: "FFFFFFFF" },
    };
    ws.getCell("A1").alignment = { horizontal: "center", vertical: "middle" };
    ws.getCell("A1").fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: TITLE_BLUE },
    };
    ws.getRow(1).height = 24;

    // ===== META INFO =====
    ws.getCell("A2").value = "Brand";
    ws.getCell("B2").value = "Angels Pizza";

    ws.getCell("A3").value = "Store";
    ws.getCell("B3").value = storess || "AllStore";

    ws.getCell("A4").value = "Date Range";
    ws.getCell("B4").value =
      `${this.state.range.tran_date["$gte"].split("T")[0]} - ` +
      `${this.state.range.tran_date["$lte"].split("T")[0]}`;

    ["A2", "A3", "A4"].forEach((cell) => {
      ws.getCell(cell).font = { bold: true };
      ws.getCell(cell).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: LIGHT_GRAY },
      };
    });

    // ===== TABLE HEADER =====
    const headerRow = 6;
    ws.getRow(headerRow).values = [
      "Date Range",
      "Time Period",
      "Average Sales",
    ];

    ws.getRow(headerRow).font = { bold: true, color: { argb: "FFFFFFFF" } };
    ws.getRow(headerRow).alignment = { horizontal: "center" };

    const borderStyle = {
      top: { style: "thin", color: { argb: BORDER } },
      left: { style: "thin", color: { argb: BORDER } },
      bottom: { style: "thin", color: { argb: BORDER } },
      right: { style: "thin", color: { argb: BORDER } },
    };

    ws.getRow(headerRow).eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: HEADER_GREEN },
      };
      cell.border = borderStyle;
    });

    // ===== DATA ROWS =====
    let rowIndex = headerRow + 1;
    const dateRange =
      `${this.state.range.tran_date["$gte"].split("T")[0]} - ` +
      `${this.state.range.tran_date["$lte"].split("T")[0]}`;

    Object.entries(averageSales).forEach(([day, sales]) => {
      [
        { period: "Morning", amount: sales.morning },
        { period: "Afternoon", amount: sales.afternoon },
      ].forEach((sale) => {
        ws.getRow(rowIndex).values = [
          dateRange,
          `${day} (${sale.period})`,
          Number(sale.amount || 0),
        ];

        ws.getCell(`C${rowIndex}`).numFmt = "#,##0.00";

        ws.getRow(rowIndex).eachCell((cell, col) => {
          cell.border = borderStyle;
          cell.alignment =
            col === 3
              ? { horizontal: "right", vertical: "middle" }
              : { horizontal: "left", vertical: "middle" };
        });

        rowIndex++;
      });
    });

    // ===== COLUMN WIDTHS =====
    ws.getColumn(1).width = 28; // Date Range
    ws.getColumn(2).width = 28; // Time Period
    ws.getColumn(3).width = 20; // Average Sales

    // ===== FREEZE + FILTER =====
    ws.views = [{ state: "frozen", ySplit: headerRow }];
    ws.autoFilter = {
      from: { row: headerRow, column: 1 },
      to: { row: headerRow, column: 3 },
    };

    // ===== DOWNLOAD =====
    const buffer = await wb.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Angels-Pizza-Total-Sales-DayOfWeek.xlsx";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }

  render() {
    const chartData = this.getChartData();
    const chartOptions = this.getChartOptions();
    const uniqueStoreCodes = this.getUniqueStoreCodes();
    const printId = "chart-container3";
    const formatSales = (sales) => {
      return sales?.toLocaleString("en-US", {
        style: "currency",
        currency: "PHP",
      });
    };

    console.log("Selecyted", this.state.selectedDate);

    return (
      <>
        <div className="d-flex justify-content-between align-items-center mb-1">
          <PageHeader
            title="Total Sales vs. Day Of Week"
            subtitle="Analyze sales distribution and trends across days of the week"
            icon="bi bi-calendar-week"
          />
          <Export
            exportCsv={() => this.exportToCSV()}
            exportPdf={() => printChart(printId)}
          />
        </div>
        <div className="row mb-2">
          <div className="col" style={{ maxWidth: "max-content" }}>
            <DateRangeReport
              onChange={this.onChangeDate.bind(this)}
              field="tran_date"
            />
          </div>

          <div className="col-sm-4">
            <div className="col-sm-12">
              <CustomSelect
                label="Store"
                options={[
                  // { value: "AllStore", label: "All Store" },
                  ...this.state.store.map((store) => ({
                    value: store.name,
                    label: store.name.replace(/_/g, " "),
                  })),
                ]}
                onChange={(selected) => this.onChangeStore(selected.value)}
                isDisabled={!this.state.range}
                error={
                  !this.state.range ? "Please select a date range first" : ""
                }
                icon="bi bi-shop"
                placeholder="Select Store"
                isClearable={true}
              />
            </div>
          </div>
        </div>
        {/* <ProgressLoader
          loaded={this.state.objects?.length}
          total={this.state.count}
          getProgressPercentage={() => this.getProgressPercentage()}
        /> */}
        {this.state.objects && this.state.objects.length > 0 ? (
          <div ref={this.chartRef1} id="chart-container3">
            <div className="card">
              {/* <Bar data={chartData} options={chartOptions} /> */}
              <HighchartsReact
                highcharts={Highcharts}
                options={this.getHighchartOptions()}
              />
            </div>
            <div className="print-only-content">
              <h2>Report Details</h2>
              <div className="print-only-content">
                <div className="">
                  <h3>Brand: Angels Pizza</h3>
                  <h3>Store: {this.state.storess}</h3>
                  <h3>Date: {this.state.selectedDate}</h3>
                </div>
              </div>
              <div className="" style={{ fontSize: "20px" }}>
                <table className="table text-center">
                  <thead>
                    <tr className="d-flex">
                      <th>Day</th>
                      <th className="ms-5">Morning Sales</th>
                      <th className="ms-5">Afternoon Sales</th>
                    </tr>
                  </thead>
                  <tbody>
                    {chartData.labels.map((label, index) => (
                      <tr className="d-flex" key={label}>
                        <td>{label}</td>
                        <td>
                          {formatSales(chartData.datasets[0].data[index])}
                        </td>
                        <td>
                          {formatSales(chartData.datasets[1].data[index])}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ) : this.state.notFound ? (
          <div className="text-center mt-5">
            <p className="text-muted fs-5">
              📭 Data not found for selected filter.
            </p>
          </div>
        ) : this.state.storess && this.state.range ? (
          <div className="text-center mt-5">
            <DefaultState />
          </div>
        ) : (
          <InitialPrompt twoFilter={true} />
        )}
      </>
    );
  }
}

export default TotalSalesWeekDayPage;
